import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { emptyObject } from 'ui-components/default-props/empty';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';

import style from '../select-products-table.module.less';

/**
 * @param {boolean} isReadOnly
 * @param {number} receivedQuantity
 * @param {number} quantity
 * @returns {string|null}
 */
const getClassName = (isReadOnly, receivedQuantity, quantity) => {
  if (!isReadOnly || typeof receivedQuantity !== 'number' || typeof quantity !== 'number') {
    return null;
  }

  if (receivedQuantity > quantity) {
    return style['quantity-received-greater'];
  }

  if (receivedQuantity < quantity) {
    return style['quantity-received-less'];
  }

  return null;
};

const ReceivedQuantityCell = ({ row, isReadOnly }) => {
  const { receivedQuantity, quantity } = row?.original || emptyObject;

  const className = getClassName(isReadOnly, receivedQuantity, quantity);

  return <Text className={className} textType={TextType.Paragraph} value={receivedQuantity} />;
};

export const createReceivedQuantityColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'receivedQuantity',
  Header: <FormattedMessage {...messages.recievedQuantityColumnHeader} />,
  Cell: ReceivedQuantityCell,
  width: 1,
});
